import { CourseDef } from '../../../../types';
import L2079365 from './2079365';
import L2079366 from './2079366';
import L2079368 from './2079368';
import L2079369 from './2079369';
import L4454335 from './4454335';
// import L5234468 from './5234468';
import L5234469 from './5234469';

export const indicadoresTecnicos: CourseDef = {
  courseTitle: 'INDICADORES TÉCNICOS',
  lessons: [
    L2079365,
    L2079366,
    L2079368,
    L2079369,
    L4454335,
    // L5234468,
    L5234469,
  ],
};

